import axios from "../../../../axios";
import React, { useEffect, useRef, useState } from "react";
import NestedReply from "./NestedReply";
import "./reply.css";
import ThreedotPopup from "./ThreedotPopup";
import EditReply from "./ThreeDot_Edit _Delete/EditReply";
import moment from "moment";
import { iconData } from "../../../../iconData";
import { IP } from "../../../../internalServer";
import { Popup } from "semantic-ui-react";
import DeleteReply from "./ThreeDot_Edit _Delete/DeleteReply";
import CrossQueryAttachment from "../Create Query/CrossQueryAttachment";
import CrossQueryAttachmentSoft from "../Create Query/CrossAttachmentSoft";
import LikePopUp from "../../Open_community/total_community_post/recent_post Img/popUpScreen";
import { getInitial } from "../../../../DCM/services/utils/name-utils";
import { Tooltip } from "@mui/material";
import MideaViewer from "../../../../midea_viewer/MideaViewer";

const Reply = ({
  queryStatus,
  reply,
  setReply,
  setNestedInput,
  setParentReply,
  setDeleted,
  setEdited,
  setFilter,
  filter,
  setChecked,
  checked,
  queryId,
  groupData,
}) => {
  // console.log(IP + reply?.user_id?.profile_picture.replace(/^\./, ""));
  let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
  const [replycpy, setreplyCnt] = useState(reply);
  const [delet, setDelet] = useState();
  const [clickThreeDot, setClickThreeDot] = useState(false);
  const [clickEditReply, setClickEditReply] = useState(false);
  const [likeClick, setLikeClick] = useState(false);
  const [likeCount, setLikeCount] = useState(reply.likes.length);
  const [attachments, setAttachments] = useState(reply.attachments);
  const [attachmentsCpy, setAttachmentsCpy] = useState(reply.attachments);
  const [likeClick1, setLikeClick1] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [responseAttach, setResponseAttach] = useState();
  const [isError, setIsError] = useState(false);
  const [mideaviewer, setMideaviewer] = useState(false);

  useEffect(() => {
    setLikeClick1(reply.likes.some((like) => like.userId === teacher_id));
  }, [reply.likes, teacher_id]);
  // let attachments = reply.attachments;
  // console.log(attachments);
  const user_id = teacher_id;
  let user;
  function isTeacherPresent(arr, targetId) {
    if (arr) {
      for (const item of arr) {
        if (item.member.id === targetId && item.member_type === "Teacher") {
          return true;
        }
      }
    }
    return false;
  }
  let isModAccess;
  if (isTeacherPresent(groupData.member || [], teacher_id)) {
    isModAccess = true;
  }

  if (user_id === reply.user_id.id) {
    user = true;
  }
  const [likedRes, setLikedRes] = useState(null);
  const handleLike = async () => {
    try {
      const updatedLikeCount = likeClick1 ? likeCount - 1 : likeCount + 1;
      setLikeClick(!likeClick);
      setLikeClick1(!likeClick1);
      setLikeCount(updatedLikeCount);
      let res = await axios.put(`/api/v1/query/reply/like/${reply.id}`, {
        user_id: user_id,
      });
      setLikedRes(res.data.data);
      // console.log(res, "tst");
    } catch (err) {
      console.log(err);
    }
  };
  useEffect(() => {
    if (likedRes) {
      setreplyCnt((prevReply) => ({ ...prevReply, ...likedRes }));
    }
  }, [likedRes, setReply]);
  const handleClickReply = () => {
    setNestedInput(true);
    setParentReply(reply);
  };

  const executeScroll = () => {
    var targetSection = document.getElementById(reply?.parent_reply_id?.id);
    targetSection.scrollIntoView({ behavior: "smooth" });
    targetSection.classList.add("highlighted");

    setTimeout(function () {
      targetSection.classList.remove("highlighted");
    }, 1000);
  };

  const handaleThreeDot = () => {
    if (clickThreeDot) {
      setClickThreeDot(false);
    } else {
      setClickThreeDot(true);
    }
  };

  const timeHelper = (a) => {
    const dateObj = new Date(a);
    const updatedDateObj = new Date(
      dateObj.getTime() + 5 * 60 * 60 * 1000 + 30 * 60 * 1000
    );
    const year = updatedDateObj.getUTCFullYear();
    const month = updatedDateObj.getUTCMonth() + 1;
    const day = updatedDateObj.getUTCDate();
    const hours = updatedDateObj.getUTCHours();
    const minutes = updatedDateObj.getUTCMinutes();
    const seconds = updatedDateObj.getUTCSeconds();

    const outputDateString = `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    return outputDateString;
  };

  const handleSoftDelete = (index) => {
    if (index < 0 || index >= attachments.length) {
      return attachments;
    }
    setAttachments([
      ...attachments.slice(0, index),
      ...attachments.slice(index + 1),
    ]);
  };
  const [isValidFileType, setIsValidFileType] = useState(true);
  const validateFileType = (filePath) => {
    var allowedExtensions =
      /(\.jpg|\.jpeg|\.png|\.pdf|\.doc|\.xlsx|\.xls|\.docx)$/i;

    if (!allowedExtensions.exec(filePath.name)) {
      setIsValidFileType(false);
      return false;
    }
    setIsValidFileType(true);
    return true;
  };
  const handleAttachment = async (files) => {
    let attachments1 = []; // Use a copy of the original attachments
    let totalSize = attachments.reduce((acc, file) => acc + file.size, 0);
    // console.log(attachments.length);
    if (files) {
      if (attachments.length + files.length > 5) {
        window.alert("You can upload a maximum of 5 files.");
        return;
      } else {
        for (const file of files) {
          const allowedTypes = [
            "application/pdf",
            "image/jpeg",
            "image/jpg",
            "image/png",
            "audio/mpeg",
            "video/mp4",
          ];
          const maxSizeInMB = file.type.startsWith("image")
            ? 5
            : file.type === "audio/mpeg"
            ? 50
            : 250;
          const maxSizeInBytes = maxSizeInMB * 1024 * 1024;

          if (!allowedTypes.includes(file.type)) {
            window.alert(
              `Only PDF, JPEG, PNG, MP3, and MP4 files are allowed.`
            );
            continue;
          }

          if (file.size > maxSizeInBytes) {
            window.alert(
              `File size exceeds ${maxSizeInMB} MB for ${file.name}.`
            );
            continue;
          }

          totalSize += file.size;

          if (totalSize > 10 * 1024 * 1024) {
            window.alert("Total attachment size should not exceed 10 MB.");
            return;
          }

          let formData = new FormData();
          formData.append("name", file.name);
          formData.append("uploadReplyAttachment", file);

          try {
            let res = await axios.post(
              `/api/v1/reply/uploadAttachment/userId/${teacher_id}`,
              formData
            );

            res && attachments1.push(res.data.data);
          } catch (error) {
            console.log(error);
          }
        }
      }
      if (attachments1.length > 0) {
        setAttachments((prev) => [...prev, ...attachments1]);
      }
    }
  };

  function shortenParagraph(text, maxLength) {
    if (text.length <= maxLength) {
      return text;
    }
    return text.slice(0, maxLength).trim() + "...";
  }
  const handleClick = (attachment) => {
    setResponseAttach(attachment);
    setIsClicked(!isClicked);
  };
  const handleClickforpdf = (attachment) => {
    setResponseAttach(attachment);
    setMideaviewer(true);
  };

  return (
    <>
      <div className="h-100 w-100 d-flex align-items-start gap-2">
        {/* Avatar */}
        <div className="imgic">
          {reply?.user_id?.role === "Teacher" ? (
            <img
              src={
                reply?.user_id?.profile_picture
                  ? IP + reply?.user_id?.profile_picture.replace(/^\./, "")
                  : reply?.user_id?.gender === "M"
                  ? "/images/Teacher_Male.jpg"
                  : reply?.user_id?.gender === "F"
                  ? "/images/Teacher_Female.png"
                  : "/images/default-profile.png"
              }
              alt="icon"
              className="profilePicImg"
              style={{
                width: "35px",
                height: "35px",
                borderRadius: "20%",
              }}
              onError={(e) => {
                // This function will run if the image fails to load
                if (reply?.user_id?.gender === "M") {
                  e.target.src = "/images/Teacher_Male.jpg";
                } else if (reply?.user_id?.gender === "F") {
                  e.target.src = "/images/Teacher_Female.png";
                } else {
                  e.target.src = "/images/default-profile.png";
                }
              }}
            />
          ) : (
            <img
              src={
                reply?.user_id?.profile_picture
                  ? IP + reply?.user_id?.profile_picture.replace(/^\./, "")
                  : reply?.user_id?.gender === "M"
                  ? reply?.user_id?.avatarProfile
                    ? "/images/Boys/" + reply?.user_id?.avatarProfile + ".webp"
                    : "/images/Student_boy_pic.png"
                  : reply?.user_id?.gender === "F"
                  ? reply?.user_id?.avatarProfile
                    ? "/images/Girls/" + reply?.user_id?.avatarProfile + ".webp"
                    : "/images/Student_girl_pic.png"
                  : "/images/default image.png"
              }
              alt="icon"
              className="prifilePicImg"
              key={reply?.user_id?.avatarProfile}
              style={{
                width: "35px",
                height: "35px",
                borderRadius: "20%",
              }}
              onError={(e) => {
                if (reply?.user_id?.gender === "M") {
                  // console.log("insie if")
                  e.target.src = reply?.user_id?.avatarProfile
                    ? "/images/Boys/" + reply?.user_id?.avatarProfile + ".webp"
                    : "/images/Student_boy_pic.png";
                } else if (reply?.user_id?.gender === "F") {
                  e.target.src = reply?.user_id?.avatarProfile
                    ? "/images/Girls/" + reply?.user_id?.avatarProfile + ".webp"
                    : "/images/Student_girl_pic.png";
                } else {
                  e.target.src = "/images/default image.png";
                }
              }}
            />
          )}
        </div>
        <div
          className="d-flex gap-3 p-1 px-2"
          style={{
            backgroundColor: "#f8f8f8",
            borderRadius: "10px",
            border: "1px solid #eee",
            alignItems: "flex-start",
            position: "relative",
            width: "96%",
          }}
          id={reply?.id}
        >
          {/* Content */}
          <div className="flex-grow-1 d-flex flex-column w-100">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <span className="badge bg-primary poppins-semibold">
                  {user ? "You" : reply.user_id.name}
                </span>

                {reply?.isDeleted && (
                  <span
                    className="ms-2 text-danger"
                    style={{ fontSize: "12px" }}
                  >
                    {/* *{user && reply?.isDeleted ? "Deleted by Teacher" : "Deleted by Student"} */}
                    {"*Deleted"}
                  </span>
                )}
              </div>

              {/* Three dot menu */}
              {isModAccess && queryStatus !== "resolved" && (
                <Popup
                  trigger={
                    <img
                      className="like_comment_icon"
                      src="/images/three dot hr.svg"
                      alt="..."
                      style={{
                        cursor: reply?.isDeleted ? "not-allowed" : "pointer",
                        opacity: reply?.isDeleted ? 0.5 : 1,
                      }}
                      onClick={
                        !reply?.isDeleted && queryStatus === "approved"
                          ? handaleThreeDot
                          : null
                      }
                    />
                  }
                  content={
                    <div className="PopupBox">
                      {clickThreeDot && (
                        <ThreedotPopup
                          setClickThreeDot={setClickThreeDot}
                          setClickEditReply={setClickEditReply}
                          setDeleted={setDeleted}
                          clickThreeDot={clickThreeDot}
                          setReply={setReply}
                          delet={delet}
                          setDelet={setDelet}
                          user={user}
                        />
                      )}
                    </div>
                  }
                  on="click"
                  hideOnScroll
                  position="bottom right"
                />
              )}
            </div>
            {/* Reply content */}
            {!clickEditReply && (
              <p
                className="comments-text mt-2 mb-2 poppins-semibold"
                style={{ whiteSpace: "pre-wrap", width: "98%" }}
              >
                {reply.reply}
              </p>
            )}

            {/* Edit reply component */}
            {clickEditReply && (
              <EditReply
                setEdited={setEdited}
                reply={reply}
                setReply={setReply}
                setClickEditReply={setClickEditReply}
                attachment={attachments}
                attachmentCopy={attachmentsCpy}
                setAttachments1={setAttachments}
                clickEditReply={clickEditReply}
                handleAttachment={handleAttachment}
                setFilter={setFilter}
                filter={filter}
                queryId={queryId}
                setAttachments={setAttachments}
              />
            )}

            <span
              className="badge bg-secondary "
              style={{ fontSize: "12px", maxWidth: "fit-content" }}
            >
              {moment(reply.updated_at).calendar({
                sameDay: "[Today]",
                lastDay: "[Yesterday]",
                lastWeek: "DD MMM ",
                sameElse: "DD MMM ",
              })}
              {"  |  "}
              {moment(reply.updated_at).calendar({
                sameDay: "hh:mm A",
                lastDay: "hh:mm A",
                lastWeek: "hh:mm A",
                sameElse: "hh:mm A",
              })}
            </span>

            {/* Like / Comment buttons */}
            {!reply?.isDeleted && (
              <div className="d-flex align-items-center gap-4 mt-2">
                {queryStatus !== "resolved" && (
                  <>
                    <div className="d-flex align-items-center gap-1">
                      <img
                        src={
                          likeClick1
                            ? "/images/blue_like.png"
                            : "/images/like.png"
                        }
                        className="like_comment_icon"
                        alt="Like"
                        onClick={
                          queryStatus === "approved" ? handleLike : () => {}
                        }
                        style={{ cursor: "pointer" }}
                      />
                      <Popup
                        on="click"
                        open={isOpen}
                        trigger={
                          <span
                            className="like_reply"
                            style={{ cursor: "pointer" }}
                            onClick={
                              queryStatus === "resolved" ? () => {} : handleLike
                            }
                          >
                            {likeClick1 ? "Liked" : "Like"}
                          </span>
                        }
                        position="bottom right"
                        content={
                          <LikePopUp
                            post={replycpy}
                            likedRes={likedRes || {}}
                            setIsOpen={setIsOpen}
                            isReply={true}
                          />
                        }
                      />
                      <span
                        className="count_like"
                        style={{ cursor: "pointer", fontSize: "12px" }}
                        onClick={() => setIsOpen(true)}
                      >
                        {likeCount}
                      </span>
                    </div>
                    <div
                      className="d-flex align-items-center gap-1"
                      onClick={handleClickReply}
                      style={{ cursor: "pointer" }}
                    >
                      <img
                        src="/images/reply.svg"
                        alt="Reply"
                        className="like_comment_icon"
                      />
                      <span style={{ fontSize: "13px" }}>Reply</span>
                    </div>
                  </>
                )}
              </div>
            )}

            {/* Nested reply link */}
            <div>
              {reply.parent_reply_id && (
                <div onClick={executeScroll} className="pt-3">
                  <NestedReply parentReply={reply.parent_reply_id} />
                </div>
              )}
            </div>

            {/* Attachments (view only) */}
            <div className="mb-2 d-flex flex-wrap gap-2 mt-2">
              {!clickEditReply &&
                attachments.length > 0 &&
                attachments.map((attachment, index) => {
                  const fileType = attachment.split(".").pop().toLowerCase();
                  const isMedia = ["jpg", "jpeg", "png", "mp4"].includes(
                    fileType
                  );
                  const isDoc = ["pdf", "ppt", "pptx"].includes(fileType);
                  return (
                    <div
                      key={index}
                      className="d-flex align-items-center gap-2 px-2 py-1 border rounded"
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        isMedia
                          ? handleClick(attachment)
                          : handleClickforpdf(attachment)
                      }
                    >
                      <img
                        src={
                          iconData?.find((i) => i.extension === fileType)?.icon
                        }
                        alt="icon"
                        style={{ height: "20px" }}
                      />
                      <span style={{ fontSize: "12px" }}>
                        {attachment.indexOf("_") > 0
                          ? attachment.substring(attachment.indexOf("_") + 1)
                          : attachment}
                      </span>
                      <span style={{ fontSize: "11px", color: "#888" }}>
                        {reply.attachments_sizeKb > 0
                          ? `(${reply.attachments_sizeKb} kb)`
                          : ""}
                      </span>
                    </div>
                  );
                })}

              {/* Attachments edit mode */}
              {clickEditReply &&
                attachments.map((item, index) => (
                  <div className="mb-3" key={index}>
                    <CrossQueryAttachmentSoft
                      key1={index}
                      attachment={item}
                      setAttach={setAttachments}
                      delete1={handleSoftDelete}
                    />
                  </div>
                ))}
            </div>

            {/* File upload during edit */}
            {clickEditReply && (
              <div className="d-flex justify-content-end mt-2">
                <input
                  id="attachFile"
                  type="file"
                  multiple
                  style={{ display: "none" }}
                  onChange={(e) => handleAttachment(e.target.files)}
                />
                <label
                  htmlFor="attachFile"
                  className="d-flex align-items-center gap-1"
                  style={{ cursor: "pointer" }}
                >
                  <img src="/images/Attach.svg" alt="attach" />
                  <span style={{ fontSize: "13px", color: "#555" }}>
                    Attach File
                  </span>
                </label>
              </div>
            )}
          </div>
        </div>

        {mideaviewer && (
          <MideaViewer
            closeMideaviewer={() => setMideaviewer(!mideaviewer)}
            attachment={responseAttach}
          />
        )}
        {isClicked &&
          (responseAttach.split(".").pop() === "mp4" ||
          responseAttach.split(".").pop() === "MP4" ? (
            <div className="fullSizeImg ">
              <div className="SubfullSizeImg">
                <video className="videoPlayer" controls>
                  <source
                    src={IP + responseAttach.replace(/^\./, "")}
                    type="video/mp4"
                  />
                </video>
                <div>
                  <img
                    className="crossIconImgQue"
                    onClick={handleClick}
                    src="/images/cross.png"
                    alt="Up Arrow"
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className="fullSizeImg ">
              <div className="SubfullSizeImg">
                {!isError ? (
                  <>
                    <img
                      className="imgMain"
                      src={IP + responseAttach?.replace(/^\./, "")}
                      alt="Full-size"
                      onError={(e) => {
                        setIsError(true);
                      }}
                    />
                    <div>
                      <img
                        className="crossIconImgQue"
                        onClick={handleClick}
                        src="/images/cross.png"
                        alt="Up Arrow"
                      />
                    </div>
                  </>
                ) : (
                  <div
                    className="fullSizeImg"
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <img
                      onClick={() => {
                        handleClick();
                        setIsError(false);
                      }}
                      src="/images/cross.png"
                      alt="Up Arrow"
                      style={{
                        position: "absolute",
                        top: "75px",
                        right: "40%",
                      }}
                    />
                    <img
                      src="/images/no-photo-1.png"
                      alt="img"
                      style={{ width: "25%" }}
                    />
                    <p
                      style={{
                        color: "red",
                        fontSize: "20px",
                        fontWeight: "500",
                        marginRight: "35px",
                      }}
                    >
                      Error!! failed to load the requested file!
                    </p>
                  </div>
                )}
              </div>
            </div>
          ))}
        {delet && (
          <DeleteReply
            setReply={setReply}
            setDeleted={setDeleted}
            replyId={reply.id}
            setDelet={setDelet}
            setFilter={setFilter}
            filter={filter}
            queryId={queryId}
          />
        )}
        {/* {clickThreeDot && (
          
        )} */}
      </div>
    </>
  );
};

export default Reply;
